//@flow
import iso8601Duration from 'app/common/lib/iso8601Duration';
import type { Pin } from 'app/packages/pinterest-flow-types/pin';
import type { Recipe } from 'app/packages/pinterest-flow-types/recipe';

export type RichPin = Pin & {
  rich_metadata: {
    recipe?: Recipe,
  },
};

const getTimeInfo = (timeInfo) => {
  const { h, m } = timeInfo || {},
    time = { hours: h || 0, minutes: m || 0 };
  return !(h === undefined && m === undefined)
    ? { h, m, time, isoDuration: iso8601Duration(time) }
    : null;
};

export const isProductPin = (pin: Pin) =>
  Boolean((pin.rich_metadata && pin.rich_metadata.products) || pin.buyable_product);

export const isTriedItPin = (pin: Pin) =>
  Boolean(
    pin.aggregated_pin_data &&
      pin.aggregated_pin_data &&
      pin.aggregated_pin_data.did_it_data &&
      !!pin.aggregated_pin_data.did_it_data.images_count &&
      pin.aggregated_pin_data.did_it_data.images_count > 0,
  );

const getRecipeInfo = (pin: RichPin) => {
  if (!pin) {
    return null;
  }

  const recipe = pin && pin.rich_metadata && pin.rich_metadata.recipe;
  const {
      name,
      categorized_ingredients: categorizedIngredients,
      diets,
      from_aggregated_data: fromAggregatedData,
      cook_times,
      servings_summary,
    } = recipe || {},
    { total, cook, prep } = cook_times || {},
    { summary: servingSummary } = servings_summary || {},
    prepTime = getTimeInfo(prep),
    cookTime = getTimeInfo(cook),
    totalTime = getTimeInfo(total);

  return {
    recipe: {
      name,
      categorizedIngredients,
      diets,
      fromAggregatedData,
      prepTime,
      cookTime,
      totalTime,
      servingSummary,
    },
  };
};

export default getRecipeInfo;
